import React from 'react';

import PropTypes from 'prop-types';

import Bar from '@/components/BI/graphicBar';
import LoadingComponent from '@/components/templates/LoadingComponent';

import { ChartContainer } from './styles';

const monthTranslations = {
    January: 'Janeiro',
    February: 'Fevereiro',
    March: 'Março',
    April: 'Abril',
    May: 'Maio',
    June: 'Junho',
    July: 'Julho',
    August: 'Agosto',
    September: 'Setembro',
    October: 'Outubro',
    November: 'Novembro',
    December: 'Dezembro'
};

const allMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const DynamicChart = ({ data, isLoading, indicatorName }) => {
    const chartOptions = {
        chartArea: { width: '90%', height: '80%', left: 60 },
        colors: ['#73A4F7'],
        explorer: { axis: 'horizontal', keepInBounds: false },
        orientation: 'horizontal',
        legend: { position: 'none' },
        fontSize: 12,
        tooltip: {
            ignoreBounds: false,
            textStyle: {
                bold: true
            }
        },
        annotations: {
            textStyle: {
                fontSize: 15,
                bold: true,
                color: '#000'
            }
        },
        hAxis: {
            title: 'Meses',
            titleTextStyle: {
                italic: false,
                color: '#9BA1A9'
            }
        },
        vAxis: {
            title: '',
            titleTextStyle: {
                italic: false,
                color: '#9BA1A9'
            }
        }
    };

    const formatGraphData = () => {
        if (!data || !data.length) {
            return [];
        }

        const formattedData = [['Mês', indicatorName || 'Valor', { role: 'annotation' }]];

        allMonths.forEach((month) => {
            const translatedMonth = monthTranslations[month];
            const monthData = data.find((item) => item.month === month);
            const count = monthData ? monthData.count : 0;
            const annotation = count;
            formattedData.push([translatedMonth, count, annotation]);
        });

        return formattedData;
    };

    const graphData = formatGraphData();
    const hasData = graphData.length > 0;

    return (
        <ChartContainer hasData={hasData}>
            {isLoading ? <LoadingComponent hideLogo /> : <Bar height="100%" width="100%" allData={graphData} options={chartOptions} />}
        </ChartContainer>
    );
};

DynamicChart.propTypes = {
    data: PropTypes.array,
    isLoading: PropTypes.bool,
    indicatorName: PropTypes.string
};

export default DynamicChart;
